import moment from "moment";

export default {
  methods: {
    $currentDateTime() {
      return moment().format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
